// extracted by mini-css-extract-plugin
export default {"defaultColor":"defaultColor-3d_Ja6"};